import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { engageLabCore } from '@jg/qiankun-micro-tool';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const currentOrg = engageLabCore.organization.takeImmediately();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, {
    key: _unref(currentOrg).id
  }))
}
}

})